<template>
  <div class="offer-filters">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'offer-filters-view'
}
</script>

<style lang="scss" scoped>

</style>
